import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import CartItemEditModal from '@/components/CartItemEditModal'
import { destroy } from '@/reducers/lineItems/asyncActions'
import { lineItemsSelector } from '@/selectors'
import { isCheckoutPath } from '@/utils/path'

const HEADER_ID = 'cart-items-count'
const buttonClasses = [
  'd-inline-block',
  'link--branded',
  'styled-as-link',
  'u-hard',
  'u-weight--medium',
  'vst-btn--transparent'
].join(' ')

const DurationEditing = ({ id }) => {
  const lineItem = useSelector(lineItemsSelector)[id]
  const { asset } = lineItem
  const dispatch = useDispatch()
  const intl = useIntl()
  const removeFromCartText = intl.formatMessage(
    { id: 'carts.remove_from_cart' }
  )
  const handleRemove = event => {
    event.preventDefault()
    dispatch(
      destroy({
        assetTitle: asset.title,
        headerId: HEADER_ID,
        itemId: id
      })
    )
  }

  return (
    <If condition={!isCheckoutPath}>
      <div className='u-weight--medium u-margin-ends'>
        <CartItemEditModal id={id} />
        <button
          aria-label={`${removeFromCartText} '${asset.title}'`}
          className={buttonClasses}
          onClick={handleRemove}
        >
          <FormattedMessage id='carts.remove_from_cart' />
        </button>
      </div>
    </If>
  )
}

DurationEditing.propTypes = { id: PropTypes.number.isRequired }

export default DurationEditing
